<template>
  <div>
    <!-- query -->
    <el-form class="text-left" ref="form" label-width="100px">
      <div class="flex-h">
        <el-form-item label="退款单编号">
          <el-input v-model.trim="queryParams.id" @keyup.native.enter="getData(1)" size="small">
          </el-input>
        </el-form-item>
        <el-form-item label="退款主id">
          <el-input
            v-model.trim="queryParams.refundMainId"
            @keyup.native.enter="getData(1)"
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="退款类型">
          <el-select v-model="queryParams.refundType" placeholder="请选择" size="small">
            <el-option
              v-for="(option, key) in refundTypeOptions"
              :key="key"
              :label="option"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款状态">
          <el-select v-model="queryParams.refundStatus" placeholder="请选择" size="small">
            <el-option
              v-for="(option, key) in refundStatusOptions"
              :key="key"
              :label="option"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="flex-h">
        <el-form-item label="订单编号">
          <el-input v-model.trim="queryParams.bizOrderId" size="small"></el-input>
        </el-form-item>
      </div>
      <el-form-item class="text-right">
        <el-button type="primary" @click="getData(1)" size="small">查询</el-button>
        <el-button type="primary" @click="exportData" size="small">导出</el-button>
        <el-button @click="onClear" size="small">清空</el-button>
      </el-form-item>
    </el-form>

    <refund-table v-if="!showLoading" :refund-list="refundList" :parent="this"> </refund-table>
    <div class="empty-msg" v-if="!refundList.length && !showLoading">{{ emptyMsg }}</div>
    <el-pagination
      v-if="refundList.length && !showLoading"
      :hide-on-single-page="!refundList.length"
      class="text-right m-tb20"
      background
      @size-change="onChangePageSize"
      @current-change="getData"
      :current-page="queryParams.currentPage"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRecord"
    >
    </el-pagination>
  </div>
</template>

<script>
import ZgTabs from '@/components/zg-tabs'
import RefundTable from './components/refund-table'
import { refundStatusCode, refuseOrderType, refuseActionType } from './code'
import { getUserId, getWebToken } from '@/common/utils/common'
import { FILE_ACCESS_PRIVATE } from '@/common/constants/'
import { validNumber } from '@/common/utils/validate.js'

export default {
  name: 'Refund',
  components: {
    RefundTable
  },
  data() {
    return {
      // 查询数据
      queryParams: {
        currentPage: 1,
        pageSize: 20,
        id: '',
        refundMainId: '',
        bizOrderId: '',
        purchaser: '',
        goodsName: '',
        refundType: '0',
        refundStatus: '0',
        refundTime: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      // page
      page: {
        pageSize: 0,
        totalRecord: 0
      },
      // data
      refundList: [],
      emptyMsg: '暂无数据',
      loadingMsg: '正在加载中...',
      showLoading: false
    }
  },
  async created() {
    await this.getData()
  },
  computed: {
    refundTypeOptions() {
      const { ALL, MONEY, GOODS, GOODS_MONEY } = refuseActionType

      return {
        [ALL]: '全部',
        [MONEY]: '退款',
        [GOODS]: '退款退货',
        [GOODS_MONEY]: '全部退款退货'
      }
    },

    refundStatusOptions() {
      const {
        INIT,
        WAITING_SELLER,
        COMFIRM_SELLER,
        REFUSE_SELLER,
        SUCCESS,
        FAILD,
        ALL
      } = refundStatusCode

      return {
        [ALL]: '全部',
        [INIT]: '退款申请中',
        [WAITING_SELLER]: '等待卖家确认',
        [COMFIRM_SELLER]: '退款中',
        [REFUSE_SELLER]: '卖家拒绝退款',
        [SUCCESS]: '退款成功',
        [FAILD]: '退款失败'
      }
    }
  },
  methods: {
    async getData(pageNum) {
      const {
        queryParams: { id, refundMainId, bizOrderId }
      } = this
      if (id && !validNumber(id)) {
        this.$message.warning('请输入正确的退款单编号!')
        return false
      }
      if (refundMainId && !validNumber(refundMainId)) {
        this.$message.warning('请输入正确的退款主id!')
        return false
      }
      if (bizOrderId && !validNumber(bizOrderId)) {
        this.$message.warning('请输入正确的订单号!')
        return false
      }
      this.showLoading = true
      this.queryParams.currentPage = pageNum || 1
      const { data, success } = await this.$post('refund.findSellerOrderRefundDetail', {
        findSellerOrderRefundDetailParam: {
          sellerId: getUserId(),
          pageNum: this.queryParams.currentPage,
          pageSize: this.queryParams.pageSize,
          id: this.queryParams.id,
          refundMainId: this.queryParams.refundMainId,
          refundStatus: this.queryParams.refundStatus,
          refundType: this.queryParams.refundType,
          bizOrderId: this.queryParams.bizOrderId
        }
      })

      if (success) {
        const { items, pageNum, pageSize, totalNum } = data[0]
        this.refundList = items || []
        this.currentPage = pageNum
        this.page.pageSize = pageSize
        this.page.totalRecord = totalNum
        this.showLoading = false
      }
    },

    onChangePageSize(size) {
      this.queryParams.currentPage = 1
      this.queryParams.pageSize = size
      this.getData()
    },

    onClear() {
      this.queryParams.id = ''
      this.queryParams.refundMainId = ''
      this.queryParams.refundType = '0'
      this.queryParams.refundStatus = '0'
      this.queryParams.bizOrderId = ''
      this.getData(1)
    },
    /** 获取订单列表 */
    async exportData() {
      if (this.page.totalRecord > 2000) {
        return this.$message.error('最多导出2000条数据')
      }
      try {
        const result = await this.$post('refund.sellerExcelExport', {
          param: {
            sellerId: getUserId(),
            id: this.queryParams.id,
            refundMainId: this.queryParams.refundMainId,
            refundStatus: this.queryParams.refundStatus,
            refundType: this.queryParams.refundType
          }
        })
        if (result.success) {
          if (result.data[0].value) {
            let downloadElement = document.createElement('a')
            downloadElement.href = `${FILE_ACCESS_PRIVATE}${
              result.data[0].value
            }&_tk=${getWebToken()}`
            document.body.appendChild(downloadElement)
            downloadElement.click()
            window.URL.revokeObjectURL(
              `${FILE_ACCESS_PRIVATE}${result.data[0].value}&_tk=${getWebToken()}`
            )
            document.body.removeChild(downloadElement)
          } else {
            this.$message.error('导出数据失败')
          }
        }
        console.log(result)
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-msg {
  width: 100%;
  height: 300px;
  line-height: 300px;
  text-align: center;
  color: #909399;
}
</style>
